import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DimensionSearchPage } from "src/components/views/spc/dimensionSearch/DimensionSearchPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/dimensionSearch")({
	staticData: { title: i18n.t("dimension_search"), legacyViewKey: "dimensionSearchPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DimensionSearchPage />;
}
